import type { BrowserLogger } from '@/util/logger/BrowserLogger';

export interface CspViolationReportOptions {
  isL4A: boolean;
  facilityId: number;
}

const stripQueryAndFragment = (uri: string): string => uri.split(/[?#]/)[0];

export const reportCspViolations = (
  target: Document,
  logger: Pick<BrowserLogger, 'info'>,
  { isL4A, facilityId }: CspViolationReportOptions
): (() => void) => {
  if (isL4A) {
    return () => undefined;
  }

  const reported = new Set<string>();
  const listener = (event: SecurityPolicyViolationEvent): void => {
    const violation = {
      disposition: event.disposition,
      effective_directive: event.effectiveDirective,
      blocked_uri: stripQueryAndFragment(event.blockedURI),
      source_file: stripQueryAndFragment(event.sourceFile),
      line_number: event.lineNumber,
      column_number: event.columnNumber,
    };
    const key = JSON.stringify(violation);
    if (reported.has(key)) {
      return;
    }
    reported.add(key);

    logger.info('CSP violation', { facility_id: facilityId, csp: violation });
  };

  target.addEventListener('securitypolicyviolation', listener);
  return () => target.removeEventListener('securitypolicyviolation', listener);
};
